

<div class="progress-container">
  <div class="progress-background">

  </div>
  <div class="progress-foreground" [ngStyle]="getBarStyle()">

  </div>
</div>